import React from "react";

const TwitterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
    >
      <path
        d="M15.5808 10.3104L24.2157 0L20.9367 0L14.1594 8.09385L8.96901 0L0 0L9.0786 14.1582L8.19695e-07 25L3.27904 25L10.5011 16.376L16.031 25L25 25L15.5808 10.3116L15.5808 10.3104ZM4.62095 2.65077L7.74743 2.65077L20.378 22.3468L17.2515 22.3468L4.62095 2.65077Z"
        fillRule="nonzero"
        transform="matrix(1 0 0 1 -0.000244141 0)"
        fill="rgb(255, 255, 255)"
      />
    </svg>
  );
};

export default TwitterIcon;
